<app-modal></app-modal>
<app-breadcum [page]="'pre-simulator'"></app-breadcum>

<div class="container pre-simulator">
  <h1 class="h-main">{{ 'simulation_content_mortgage_simulator' | translate }}</h1>
  <p class="info-text">{{ 'simulation_content_msg' | translate }}</p>
  <app-pre-simulator-form
    [isAdvanceSimulator]="false"
    (onSimulate)="generateSimunation($event)"
  ></app-pre-simulator-form>
  @if (showSimulation) {
    <app-simulation-result [simulateResult]="dataSimulate"></app-simulation-result>
    <div class="content-buttons d-flex justify-content-end">
      <button id="btn-reset-simulate" class="filled btn btn-01" type="button" (click)="resetSimulator()">
        {{ 'simulation_content_btn_reset' | translate }}
      </button>
      <button id="btn-request-custom-study" class="filled btn btn-02" type="button" (click)="requestCustomStudy()">
        {{ 'simulation_content_btn_request_custom_study' | translate }}
      </button>
    </div>
  }
</div>
